import { ReceiptAlertTypeFilter } from '@synergy/components';

import { ClassificationsFilter } from '../../../common/components/filter/classifications-filter';
import { CustomerContactFilter } from '../../../common/components/filter/customer-contact-filter';
import { CustomerFilter } from '../../../common/components/filter/customer-filter';
import { LegacySupplierFilter } from '../../../common/components/filter/legacy-supplier-filter';
import { PaloFilterPanel } from '../../../common/components/palo/palo-filter-panel';
import { ResponsibleContactFilter } from '../../../common/components/filter/responsible-contact-filter';
import { fetchAllClassifications } from '../../configuration/organization/classifications/store/classifications-actions';
import { useAppSelector } from '../../../store/use-appstate-selector';
import { useThunkDispatch } from '../../../store/use-thunk-dispatch';

/**
 * PALO filter for this list.
 *
 * The rows above come from the list itself and cover every field it declared,
 * each with its own comparison. What stays here are the ones that look a
 * record up by name and hand over its id, which no generic control can do.
 *
 * Gone with the rows: the date range, which the declared `createdAt` now
 * offers with `ab`, `bis` and `zwischen` — offering the same filter twice is
 * what made the toolbar confusing before (#2184). The status filter stays out
 * as well: the sub-views of the navigation set it, and correctly (#2144).
 *
 * The rating went the same way. It stood here beside its own declared row,
 * and the one that was read was the row — so picking a rating here did
 * nothing at all: no request, no chip (#2231 R-119).
 */
export const PaloInquiryOverviewFilter = () => {
    const dispatch = useThunkDispatch();
    const classifications = useAppSelector(state => state.classifications.classifications.items);

    return (
        <PaloFilterPanel listKey="inquiries">
            <ResponsibleContactFilter />
            <CustomerFilter />
            <CustomerContactFilter />
            <LegacySupplierFilter />
            <ClassificationsFilter
                classifications={classifications}
                fetchClassifications={() => dispatch(fetchAllClassifications())}
            />
            <ReceiptAlertTypeFilter />
        </PaloFilterPanel>
    );
};
